import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Router} from "@angular/router";

@Component({
  selector: 'global-search-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less']
})

export class GlobalSearchListComponent {
  @Input()
  public results: any[] = [];

  @Output() onRowClick: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router) {
  }

  onItemClick(item) {
    if (item.type == "AREA") {
      this.router.navigate(['areas', item.id, 'things']);
    } else {
      this.router.navigate(['things', item.id]);
    }

    if (this.onRowClick) {
      this.onRowClick.emit(item);
    }
  }


  getIcon(item: any) {
    switch (item.type.toUpperCase()) {
      case "TRASH":
        return "kng-icon-trash";
      case "RECYCLE":
        return "kng-icon-recycle";
      case "RESTROOM_MALE":
        return "kng-icon-restroom-men";
      case "RESTROOM_FEMALE":
        return "kng-icon-restroom-women";
      default:
        return "kng-icon-location";
    }
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/components/globalSearch/list/list.component.ts